// app/javascript/turbo_config.js
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false
export { Turbo }